var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('container-item-wrapper', {
    attrs: {
      "widget": _vm.widget
    }
  }, [_c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.widget.options.hidden),
      expression: "!widget.options.hidden"
    }],
    ref: _vm.widget.id,
    staticClass: "grid-container",
    class: [_vm.customClass],
    attrs: {
      "gutter": _vm.widget.options.gutter
    }
  }, [_vm._l((_vm.widget.cols), function(colWidget, colIdx) {
    return [_c('grid-col-item', {
      key: colIdx,
      attrs: {
        "widget": colWidget,
        "parent-list": _vm.widget.cols,
        "index-of-parent-list": colIdx,
        "parent-widget": _vm.widget,
        "col-height": _vm.widget.options.colHeight,
        "sub-form-row-id": _vm.subFormRowId,
        "sub-form-row-index": _vm.subFormRowIndex,
        "sub-form-col-index": _vm.subFormColIndex
      },
      scopedSlots: _vm._u([_vm._l((Object.keys(_vm.$scopedSlots)), function(slot) {
        return {
          key: slot,
          fn: function(scope) {
            return [_vm._t(slot, null, null, scope)]
          }
        }
      })], null, true)
    })]
  })], 2)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56baf7a7","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-render/container-item/grid-item.vue
// module id = null
// module chunks = 